import React, { useState, useEffect } from 'react';
import '../CSS/Global.css';
import { useSidebar } from '../SidebarContext';
import Header from './Header';
import Sidebar from './SideBar';
import TeamDirectoryModal from './TeamDirectoryModal';

const TeamDirectory = () => {
    const { isSidebarOpen } = useSidebar();
    const [isModalOpen, setIsModalOpen] = useState(false);

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    const [employees, setEmployees] = useState([
        // Sample data (replace with actual data)
        { dob: '1990-05-15', name: 'John Doe', gender: 'Male', department: 'Engineering', employeeId: 'E12345', mobile: '123-456-7890', jobTitle: 'Software Engineer', status: 'Active' },
        { dob: '1985-03-22', name: 'Jane Smith', gender: 'Female', department: 'Marketing', employeeId: 'M67890', mobile: '987-654-3210', jobTitle: 'Marketing Manager', status: 'Deactive' },
        { dob: '1992-08-30', name: 'Alice Brown', gender: 'Female', department: 'HR', employeeId: 'H54321', mobile: '555-555-5555', jobTitle: 'HR Specialist', status: 'Active' },
    ]);
    const [filteredEmployees, setFilteredEmployees] = useState(employees);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = employees.filter((employee) =>
            Object.values(employee).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, employees]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    const currentData = filteredEmployees.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    const toggleStatus = (index) => {
        setEmployees((prevEmployees) =>
            prevEmployees.map((emp, i) =>
                i === index
                    ? { ...emp, status: emp.status === 'Active' ? 'Deactive' : 'Active' }
                    : emp
            )
        );
    };

    const handleDelete = (index) => {
        const updatedData = currentData.filter((_, i) => i !== index);
        setEmployees(updatedData);
    };

    return (
        <>
          
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Team Directory</h1>

                    {/* Add Fees Button */}
                    <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add employee
                    </button>
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Team Directory Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>DOB</th>
                                <th>Name</th>
                                <th>Gender</th>
                                <th>Department</th>
                                <th>Employee ID</th>
                                <th>Mobile</th>
                                <th>Job Title</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((employee, index) => (
                                    <tr key={index}>
                                        <td>{employee.dob}</td>
                                        <td>{employee.name}</td>
                                        <td>{employee.gender}</td>
                                        <td>{employee.department}</td>
                                        <td>{employee.employeeId}</td>
                                        <td>{employee.mobile}</td>
                                        <td>{employee.jobTitle}</td>
                                        <td>
                                            <button onClick={() => setIsModalOpen(true)}>
                                                <i className="fa fa-pen"></i> {/* Edit Button */}
                                            </button>
                                            <button onClick={() => toggleStatus(index)}>
                                                <i
                                                    className={`fa ${employee.status === 'Active'
                                                            ? 'fa-toggle-on'
                                                            : 'fa-toggle-off'
                                                        }`}
                                                ></i> {/* Toggle Status */}
                                            </button>
                                            <button onClick={() => handleDelete(index)}>
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: 'center' }}>
                                        No employees found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    {Array.from({ length: totalPages }, (_, index) => (
                        <button
                            key={index}
                            onClick={() => paginate(index + 1)}
                            className={currentPage === index + 1 ? 'active' : ''}
                        >
                            {index + 1}
                        </button>
                    ))}
                    <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            </div>

            <TeamDirectoryModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} />
        </>
    );
};

export default TeamDirectory;
